import React, {Component} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Button } from 'antd';
import Title from '../../common/title';
import OtherVideo from '../otherVideo';
import OtherTable from '../../common/otherTable';

let index, noClick = false, videoIdx = 0;
class RealTime extends Component {
  state = {
    isFullScreen: false,
    autoPlay: false,
    offsetDur: 0,
    num: 0,
    options: {
      credits: {
        enabled: false
      },
      chart: {
        type: 'bar',
        height: 250
      },
      title: null,
      colors: [this.props.themeColor],
      xAxis: {
        lineWidth: 0,
        categories: [],
        crosshair: true
      },
      yAxis: {
        opposite: true,
        gridLineColor: 'rgba(61, 136, 241, 0.1)',
        title: null,
        min: 0,
        minRange: 1
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        bar: {
          dataLabels: {
            allowOverlap: false
          },
          pointWidth: 4
        }
      },
      series: [],
    }
  }

  isIE11 = () => {
      const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;

      const browser = {
        versions: function () {
          const u = navigator.userAgent;
          return {
            trident: u.indexOf('Trident') > -1, //IE内核
          };
        }()
      }
      return browser.versions.trident && !isIE11;
    }

  fullScreen = () =>{
    this.setState({
      isFullScreen: !this.state.isFullScreen
    }, () => {
      let el, rfs;
      noClick = false;
      if(this.state.isFullScreen) {
        noClick = true;
        el = document.documentElement;
        rfs = el.requestFullscreen || el.webkitRequestFullScreen ||
          el.mozRequestFullScreen || el.msRequestFullscreen;
      } else {
        el = document;
        rfs = el.cancelFullScreen || el.webkitCancelFullScreen ||
          el.mozCancelFullScreen || el.msExitFullscreen || el.exitFullscreen;
      }
      if (rfs) { //typeof rfs != "undefined" && rfs
        rfs.call(el);
      } else if (typeof window.ActiveXObject != "undefined") {
        //for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
        let wscript = new ActiveXObject("WScript.Shell");
        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    });
  }

  getRefVideoPlayer = (data) => {
    const refs = this.refs.videoReportBox && this.refs.videoReportBox.getRefVideoPlayer();
    if(refs && refs.videoPlayer) {
      videoIdx = 0;
      this.setState({
        offsetDur: data.offsetDur || 0
      });
      const refsBox = this.refs.videoBox && this.refs.videoBox.getRefVideoPlayer();
      const currTime = refsBox.videoPlayer && refsBox.videoPlayer.current && refsBox.videoPlayer.current.currentTime || 0;
      refs.videoPlayer.current.currentTime = (data.offsetDur || 0) + currTime;
      if(this.state.autoPlay) {
        refs.videoPlayer.current.play();
      }
    } else {
      if(videoIdx < 10) {
        videoIdx++;
        console.log('videoIdx: ', videoIdx);
        let time = setTimeout(() => {
          clearTimeout(time);
          this.getRefVideoPlayer(data);
        }, 200);
      }
    }
  }

  changeNum = (type) => {
    this.setState({
      autoPlay: true,
      num: type === 'add' ? this.state.num + 1 : this.state.num - 1
    }, () => {
      //试题信息
      const interviewQuesVOs = this.props.paperInfo && this.props.paperInfo.interviewQuesVOs;
      this.props.handleClick(interviewQuesVOs[this.state.num] && interviewQuesVOs[this.state.num].questionId, data => {
        videoIdx = 0;
        this.getRefVideoPlayer(data);
      });
    });
  }

  handleTimeUpdate = (currentTime, res) => {
    const { result, i18n } = this.props;
    const data = res || result;
    const currentResult = data && data.data && data.data[this.state.num] || {};
    if(!currentTime) return false;
    const index = (parseInt(currentTime * data.frameRate) || 1) + "";
    const currentEmos = currentResult[index] && currentResult[index].emos || {};
    let categories = [], series = [];
    for(let i in currentEmos) {
      if(i !== 'attention') {
        categories.push(i18n.report.emotion[i]);
        series.push(currentEmos[i] || 0);
      }
    }
    if(categories.length === 0 && this.state.options.xAxis.categories && this.state.options.xAxis.categories.length > 0) {
      categories = this.state.options.xAxis.categories;
    }
    if(!(this.state.options.xAxis.categories.length > 0) && !(categories.length > 0)) {
      categories = ["愤怒", "蔑视", "厌恶", "害怕", "喜悦", "平静", "悲哀", "惊讶"];
    }
    if(categories.length > 0) {
      this.setState({
        options: {
          xAxis: {
            categories
          },
          series: [{
            name: i18n.report.summaryInfo3,
            data: series.length > 0 ? series : new Array(categories.length).fill(0)
          }]
        }
      });
    }
  }

  componentDidMount() {
    window.onresize = () => {
      let isFull = document.fullScreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || false;
      if(!isFull && noClick) {
        this.fullScreen();
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(nextProps.result && this.state.options.series.length === 0) {
      this.handleTimeUpdate(0.001, nextProps.result);
    }
  }

  componentWillUnmount() {
    noClick = false;
    videoIdx = 0;
  }

  render() {
    const { num, options, autoPlay, isFullScreen, offsetDur } = this.state;
    const { i18n, summary, themeColor, videoUrl, videoReportUrl } = this.props;

    const columns = () => {
      index = null;
      const arr = [{
        title: i18n.report.summaryInfo5,
        dataIndex: 'title',
        key: 'title',
        align: 'center'
      }];
      const categories = summary && summary.histogram && summary.histogram.categories || [];
      for(let i = 0; i < categories.length; i++) {
        if(categories[i] !== '注意力') {
          arr.push({
            title: categories[i],
            dataIndex: i.toString(),
            key: i.toString(),
            align: 'center',
            ellipsis: true,
            render: (text, record) => <React.Fragment>
              {record[`${i}_strength`] === 1 ? <strong style={{color: 'black'}}>{text}</strong> : text}
            </React.Fragment>
          });
        } else {
          index = i;
        }
      }
      return arr;
    }

    const dataSource = () => {
      const arr = [{
        key: 0,
        title: i18n.report.summaryInfo3
      }, {
        key: 1,
        title: i18n.report.summaryInfo4
      }];
      const series = summary && summary.histogram && summary.histogram.series || [];
      const currentSeries = series[num] && series[num].data || [];
      for(let i = 0; i < currentSeries.length; i++) {
        if(index && i !== index) {
          arr[0][i.toString()] = currentSeries[i].score;
          arr[1][i.toString()] = currentSeries[i].strengthDesc;
          arr[1][`${i}_strength`] = currentSeries[i].strength;
        }
      }
      return arr;
    }

    return (
      <div className="mrg25">
        <Title iconfont="icon-zu22024">{{title: i18n.result.realTimeInfo}}</Title>
        <div className="realTimeCon mgin60 mrgt16 borderBlack">
          <div className="summaryTitle"><i style={{backgroundColor: themeColor}} />{i18n.report.questionNum.replace('${num}', num + 1)}<span>{i18n.report.questionTotal.replace('${num}', summary && summary.histogram && summary.histogram.series && summary.histogram.series.length || 0)}</span></div>
          <div className="questionData">
            <span className="questionText"><i>Q：</i>{summary && summary.histogram && summary.histogram.series && summary.histogram.series[num] && summary.histogram.series[num].questionName}</span>
            <div className="questionBtn">
              <Button onClick={() => this.changeNum('less')} disabled={num <= 0}>{i18n.result.lastQue}</Button>
              <Button onClick={() => this.changeNum('add')} disabled={num === (summary && summary.histogram && summary.histogram.series && (summary.histogram.series.length - 1) || 0)} style={{backgroundColor: themeColor, borderColor: themeColor}} type="primary">{i18n.result.nextQue}</Button>
            </div>
          </div>
          <div className="videoQuesBox">
            <div className="videoBox">
              <div className={`videoBoxCon ${isFullScreen ? 'fullVideoBox' : ''}`}>
                <OtherVideo offsetDur={offsetDur} changeVideo={this.refs.videoReportBox} handleTimeUpdate={this.handleTimeUpdate} videoUrl={videoUrl}
                            ref="videoBox" themeColor={themeColor} autoPlay={autoPlay} />
                <OtherVideo className="videoReportBox" noOption={true} videoUrl={videoReportUrl} themeColor={themeColor}
                            ref="videoReportBox" autoPlay={autoPlay} muted={true} />
                {!this.isIE11() && <div className="video-controls-full-screen">
                  <span className="video-controls-btn" onClick={() => this.fullScreen()}>
                  {isFullScreen ? <i className="iconfont icon-small-screen"></i> :
                    <i className="iconfont icon-full-screen"></i>}
                  </span>
                </div>}
              </div>
            </div>
            <div className="questionBox">
              <HighchartsReact
                highcharts={Highcharts}
                options={options}
              />
              <div className="tableBox">
                <OtherTable columns={columns()} dataSource={dataSource()} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RealTime;
